import { Box, Flex, Heading, Text } from "@radix-ui/themes";
import type { ReactNode } from "react";

interface FeatureBoxProps {
  title: string;
  icon: ReactNode;
  children: ReactNode;
  variant?: "dark" | "light";
}

const themes = {
  dark: {
    container: {
      backgroundColor: "#202939",
      border: "1px solid #364153",
      color: "white",
    },
    iconBox: {
      backgroundColor: "#273A47",
      color: "#68d1bf",
    },
    text: {
      color: "inherit",
    },
  },
  light: {
    container: {
      backgroundColor: "#f1f5f9",
      border: "1px solid #cbd5e1",
      color: "#1e293b",
    },
    iconBox: {
      backgroundColor: "#dbeafe",
      color: "#0369a1",
    },
    text: {
      color: "#475569",
    },
  },
};

export function FeatureBox({
  title,
  icon,
  children,
  variant = "dark",
}: FeatureBoxProps) {
  const theme = themes[variant];

  return (
    <Box
      flexGrow="1"
      flexBasis="0"
      style={{
        ...theme.container,
        padding: "1.5rem",
        borderRadius: "8px",
      }}
    >
      <Flex direction="column" gap="3">
        <Box
          style={{
            ...theme.iconBox,
            padding: "12px 12px",
            borderRadius: "14px",
            width: "fit-content",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon}
        </Box>
        <Heading size="4" weight="medium">
          {title}
        </Heading>
        <Text size="2" style={theme.text}>
          {children}
        </Text>
      </Flex>
    </Box>
  );
}
